import React, { useState, useRef, useEffect } from 'react';
import './StrategyStyles.css'; // reuse existing styles
function CustomDropdown({ options, value, onChange, placeholder = "Select a strategy", renderOption, openUpward = false, disabled = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (disabled) {
      setIsOpen(false);
    }
  }, [disabled]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const getDisplayLabel = (option) => {
    if (renderOption && option) {
      return renderOption(option);
    }
    // If option has flags property, include them
    if (option?.flags) {
      return (
        <span style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '6px',
          fontFamily: "'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', 'EmojiOne Color', 'Android Emoji', sans-serif"
        }}>
          <span style={{ fontSize: '1.2em', lineHeight: '1' }}>{option.flags}</span>
          <span>{option.label}</span>
        </span>
      );
    }
    return option?.label || '';
  };

  return (
    <div className={`custom-dropdown${disabled ? ' custom-dropdown--disabled' : ''}`} ref={dropdownRef}>
      <div
        className="custom-dropdown-header"
        onClick={() => {
          if (disabled) return;
          setIsOpen(!isOpen);
        }}
      >
        {value ? getDisplayLabel(options.find(o => o.value === value)) : placeholder}
        <span className="arrow">{isOpen ? "▲" : "▼"}</span>
      </div>
      {isOpen && (
        <div 
          className="custom-dropdown-list"
          style={openUpward ? {
            bottom: '100%',
            top: 'auto',
            marginBottom: '4px'
          } : {}}
        >
          {options.map((option) => (
            <div
              key={option.value}
              className="custom-dropdown-item"
              onClick={() => handleSelect(option.value)}
            >
              {getDisplayLabel(option)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomDropdown;
